module.exports = __webpack_public_path__ + "static/media/Skin02.b460348f.jpeg";